import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;

  .label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-muted);
    padding: 0 0 10px;
  }

  .value {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: var(--color-text);
    display: flex;
    gap: 10px;

    .pencil {
      cursor: pointer;

      &:hover {
        color: var(--color-link);
      }
    }
  }
`;
